import { ELEMENT } from './enum';

export const namespace = 'ac';

export const sys = {
	url: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '/static',
}

export const storage = {
	theme: `${namespace}.theme`,
	spoiler: `${namespace}.spoiler`,
	productFilters: `${namespace}.productFilters`,
};

export const arcadia = {
	cp: {
		url: 'https://cp.arcadia-online.org',
	},
};

export const elementalOrder = [
	ELEMENT.FIRE,
	ELEMENT.EARTH,
	ELEMENT.AIR,
	ELEMENT.WATER,
];
